export const languages = {
  cs: "Česky",
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  "en-GB": "English (UK)",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  hu: "Magyar",
  nl: "Nederlands",
  no: "Norsk",
  pl: "Polski",
  "pt-BR": "Português - Brasil",
  ru: "Русский",
  fi: "Suomi",
  sv: "Svenska",
  zh: "简体中文",
  "zh-Hant": "繁體中文"
};
